import { createFileRoute } from '@tanstack/react-router'

import { BugList } from '@/components/bugs/bug-list'
import { Frame } from '@/components/frame'
import { PageHeader } from '@/components/page-header'
import { useBarSync } from '@/hooks/use-bar-sync'
import { BUG_SEVERITIES, BUG_STATUSES } from '@/lib/bug-values'
import { csvOf, integer, matching, readSearch, text } from '@/lib/search-params'

/** Lot 47 : tous les bugs signalés, filtres dans l'URL. */
export const Route = createFileRoute('/_app/qa/bugs/')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        etats: csvOf(BUG_STATUSES),
        gravites: csvOf(BUG_SEVERITIES),
        client: matching(/^[0-9a-f]{24}$/),
        // #401 : un projet, ou `none` pour les bugs sans projet.
        projet: matching(/^([0-9a-f]{24}|none)$/),
        q: text(),
        page: integer({ min: 1 }),
      },
      search,
    ),
  component: BugsPage,
})

function BugsPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  // #401 : le client et le projet de la barre sont les filtres de la liste.
  useBarSync(search, (next) => {
    void navigate({
      search: (current) => ({
        ...current,
        client: next.client,
        projet: next.projet,
        page: undefined,
      }),
      replace: true,
    })
  })
  return (
    <div className="space-y-6">
      <PageHeader title="Bugs" documentTitle="Bugs" />
      <Frame>
        <BugList
          search={search}
          onSearchChange={(next) => {
            void navigate({ search: (current) => ({ ...current, ...next }), replace: true })
          }}
        />
      </Frame>
    </div>
  )
}
